import { Locales } from '@griply/types';
import { LocalizedText } from '@griply/utils';
import imagePage1 from 'shared/assets/images/whats-new/calendar-settings.jpg';
import imagePage1x2 from 'shared/assets/images/whats-new/calendar-settings@2x.jpg';
import imagePage1x3 from 'shared/assets/images/whats-new/calendar-settings@3x.jpg';
import imagePage2 from 'shared/assets/images/whats-new/calendar-timeslots.jpg';
import imagePage2x2 from 'shared/assets/images/whats-new/calendar-timeslots@2x.jpg';
import imagePage2x3 from 'shared/assets/images/whats-new/calendar-timeslots@3x.jpg';

// Deliberate mobile parallel — `image`/`imageSrcSet` are platform-divergent and the content is not shared.
export type WhatsNewBullet = {
  title: LocalizedText;
  description?: LocalizedText;
};

export type WhatsNewPage = {
  image?: string;
  imageSrcSet?: string;
  newBadge?: boolean;
  title: LocalizedText;
  subtitle?: LocalizedText;
  bullets: WhatsNewBullet[];
  link?: { url: string; title: LocalizedText };
};

export type WhatsNewContent = {
  version: string;
  pages: WhatsNewPage[];
};

// The dialog is keyed to `version`, NOT the app's build version. Each user is
// shown a given `version` exactly once (tracked in the profile). Rules:
//
// - New notes to show      → bump `version` AND replace the pages.
// - Same notes, new build   → leave `version` (hot fix, patch, phased reship).
//   This is how patch releases (3.xx.1 / 3.xx.2) are skipped: leave `version`.
// - No dialog at all        → set the whole value to `null`.
//
// Bumping `version` re-shows the dialog to everyone who already saw the old one;
// leaving it still reaches anyone who skipped the prior build.
export const WHATS_NEW_CONTENT: WhatsNewContent | null = {
  version: '3.51.0',
  pages: [
    {
      image: imagePage1,
      imageSrcSet: `${imagePage1} 1x, ${imagePage1x2} 2x, ${imagePage1x3} 3x`,
      newBadge: true,
      title: { [Locales.EnUS]: '2-way calendar sync' },
      subtitle: {
        [Locales.EnUS]:
          'Sync your tasks and habits effortlessly to your calendar.',
      },
      bullets: [
        {
          title: { [Locales.EnUS]: 'Flexible' },
          description: {
            [Locales.EnUS]:
              'Pick which goal or life area syncs to which calendar.',
          },
        },
        {
          title: { [Locales.EnUS]: 'Auto or manual' },
          description: {
            [Locales.EnUS]:
              'Sync all tasks automatically, or only the tasks that are non-negotiable.',
          },
        },
        {
          title: { [Locales.EnUS]: 'Privacy' },
          description: {
            [Locales.EnUS]:
              'Hide task details to keep sensitive tasks private.',
          },
        },
      ],
      link: {
        url: 'https://griply.app/help',
        title: { [Locales.EnUS]: 'Learn more' },
      },
    },
    {
      image: imagePage2,
      imageSrcSet: `${imagePage2} 1x, ${imagePage2x2} 2x, ${imagePage2x3} 3x`,
      newBadge: true,
      title: { [Locales.EnUS]: 'Create smart list and tag time slots' },
      subtitle: {
        [Locales.EnUS]:
          'Sync your tasks and habits effortlessly to your calendar.',
      },
      bullets: [
        {
          title: { [Locales.EnUS]: 'Flexible' },
          description: {
            [Locales.EnUS]: 'Block time to work on your "Deep focus" tag tasks',
          },
        },
        {
          title: { [Locales.EnUS]: 'Auto or manual' },
          description: {
            [Locales.EnUS]:
              'Sync all tasks automatically, or only the tasks that are non-negotiable.',
          },
        },
        {
          title: { [Locales.EnUS]: 'Privacy' },
          description: {
            [Locales.EnUS]:
              'Hide task details to keep sensitive tasks private.',
          },
        },
      ],
    },
    {
      title: { [Locales.EnUS]: 'Other improvements and fixes' },
      bullets: [
        {
          title: { [Locales.EnUS]: 'Flexible' },
          description: {
            [Locales.EnUS]: 'Block time to work on your "Deep focus" tag tasks',
          },
        },
        {
          title: { [Locales.EnUS]: 'Auto or manual' },
          description: {
            [Locales.EnUS]:
              'Sync all tasks automatically, or only the tasks that are non-negotiable.',
          },
        },
        {
          title: { [Locales.EnUS]: 'Privacy' },
          description: {
            [Locales.EnUS]:
              'Hide task details to keep sensitive tasks private.',
          },
        },
        {
          title: { [Locales.EnUS]: 'Flexible' },
          description: {
            [Locales.EnUS]: 'Block time to work on your "Deep focus" tag tasks',
          },
        },
        {
          title: { [Locales.EnUS]: 'Auto or manual' },
          description: {
            [Locales.EnUS]:
              'Sync all tasks automatically, or only the tasks that are non-negotiable.',
          },
        },
        {
          title: { [Locales.EnUS]: 'Privacy' },
          description: {
            [Locales.EnUS]:
              'Hide task details to keep sensitive tasks private.',
          },
        },
        {
          title: { [Locales.EnUS]: 'Flexible' },
          description: {
            [Locales.EnUS]: 'Block time to work on your "Deep focus" tag tasks',
          },
        },
        {
          title: { [Locales.EnUS]: 'Auto or manual' },
          description: {
            [Locales.EnUS]:
              'Sync all tasks automatically, or only the tasks that are non-negotiable.',
          },
        },
        {
          title: { [Locales.EnUS]: 'Privacy' },
          description: {
            [Locales.EnUS]:
              'Hide task details to keep sensitive tasks private.',
          },
        },
        {
          title: { [Locales.EnUS]: 'Flexible' },
          description: {
            [Locales.EnUS]: 'Block time to work on your "Deep focus" tag tasks',
          },
        },
        {
          title: { [Locales.EnUS]: 'Auto or manual' },
          description: {
            [Locales.EnUS]:
              'Sync all tasks automatically, or only the tasks that are non-negotiable.',
          },
        },
        {
          title: { [Locales.EnUS]: 'Privacy' },
          description: {
            [Locales.EnUS]:
              'Hide task details to keep sensitive tasks private.',
          },
        },
      ],
    },
  ],
};
